import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { capitalizeFirstLetter } from '../../Helpers/Calculations';
import PdfSection from './PdfSection';

const styles = StyleSheet.create(
    {
        tab: { marginTop: 30, marginLeft: 10, marginRight: 10, width: "100%" },
        title: { fontSize: 12, borderBottom: '1 solid #747679', width: '95%', fontFamily: "RobotoRegular", color: '#373534' },
    }
)

const PdfTab = props => {
    const { name, sections, form } = props;

    return <View style={styles.tab}>
        <Text style={styles.title}>{capitalizeFirstLetter(name)}</Text>
        {sections.map(s =>
            <PdfSection
                key={s.name}
                name={s.name}
                fields={s.fields}
                fieldDefs={form.fieldDefs}
                fieldState={form.fieldState}
                formData={form.formData}
                dataFetchResolver={form.gtr}
                meta={form.meta}
            />)}
    </View>
}

export default PdfTab;
